import IdentifiableDto from 'modules/base/dto/IdentifiableDto';
import NamedDto from 'modules/base/dto/NamedDto';

export default class EdaItemTableDto extends IdentifiableDto {
	constructor() {
		super();
		/** @type {NamedDto} */
		this.edaType = null;
		/** @type {NamedDto} */
		this.sensorType = null;
		/** @type {Date} */
		this.created = null;
		/** @type {Date} */
		this.updated = null;
		/** @type {string} */
		this.file = null;
	}

	/**
	 * @typedef {Object} _EdaItemTableDtoProps
	 * @property {NamedDto} edaType
	 * @property {NamedDto} sensorType
	 * @property {Date} created
	 * @property {Date} updated
	 * @property {string} file
	 *
	 * @typedef {import("modules/base/dto/IdentifiableDto").IdentifiableDtoProps & _EdaItemTableDtoProps} EdaItemTableDtoProps
	 */
	/**
	 *
	 * @param {EdaItemTableDtoProps} props
	 * @returns {EdaItemTableDto}
	 */
	setup(props) {
		super.setup(props);
		this.edaType = props.edaType !== null ? new NamedDto().setup(props.edaType) : null;
		this.sensorType = props.sensorType !== null ? new NamedDto().setup(props.sensorType) : null;
		this.created = props.created !== null ? new Date(props.created) : null;
		this.updated = props.updated !== null ? new Date(props.updated) : null;
		return this;
	}
}
